import React, { useEffect, useState, useContext } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Autocomplete from "@mui/material/Autocomplete";
import DataTable from "../../components/DataTable/DataTable";
import {
  getRecruiterDetails,
  getRecruitmentLeaderbyorg,
} from "../../apis/organisationAdminAPI/manageDivision";
import getAllTeamLeaderByOrg from "../../apis/teamLeaderbyOrg/getAllTeamLeaderByOrg";
import addTeam from "../../apis/addTeam/addTeam";
import getTeamDetails from "../../apis/teambyOrganizationId/getAllTeamByOrgId";
import updateTeamDetail from "../../apis/updateTeam/updateTeamDetails";
import { UserTypeContext } from "../../AppRoute";
import PeopleIcon from "@mui/icons-material/People";
import "./manageTeam.css";
import checkExistsRequisition from "../../apis/checkRequisitionExists/checkRequisitionExists";
import getAllRequisitionOfRecLead from "../../apis/getAllRequisitionOfRecLead/getAllRequisitionOfRecLead";
import mergeTeam from "../../apis/mergeTeam/mergeTeam";
import ReassignRecruiterModal from "../../components/ReassignRecruiterModal/ReassignRecruiterModal";
import MergeTeamModal from "../../components/MergeTeamModal/MergeTeamModal";
import Tooltip from '@mui/material/Tooltip';
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";

const ManageTeam = (props) => {
  const location = useLocation();
  const { userType, userRecords } = useContext(UserTypeContext);
  const userRecruitmentpartnerId =
    userType === "Admin"
      ? location?.state?.recruitmentPartnerId
      : userRecords?.recruitmentpartnerId;
  const idContextTest =
    userType === "Admin" ? location?.state?.id : userRecords?.id;
  const userRole =
    userType === "Admin"
      ? location?.state?.userRole
      : userRecords?.role?.roleName;
  const userRecordData =
    userType === "Admin" ? location?.state?.userRecords : userRecords;
  const history = useNavigate();

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogRecruiterAssingment, setopenDialogRecruiterAssingment] =
    useState(false);
  const [activeRequAssign, setactiveRequAssign] = useState([]);
  const [teamActiveRecruiter, setTeamActiveRecruiter] = useState([]);
  const [teamRecruiter, setteamRecruiter] = useState([]);
  const [defaultTeamRecruiter, setdefaultTeamRecruiter] = useState([]);
  const [selctedRecruiter, setSelctedRecruiter] = useState([]);
  const [editedRow, setEditedRow] = useState({});
  const [isUserDataUpdating, setIsUserDataUpdating] = useState(false);
  const [teamInfo, setTeamInfo] = useState({
    teamName: "",
    recruitmentLeader: "",
    teamLeader: "",
    selectedRecruiterId: [],
    selectedRecruiter: [],
    currentRecruiterValue: [],
    isActive: { name: "True", value: true },
    previousRecruitmentLeader: "",
  });
  const [allTeam, setAllTeam] = useState([]);
  const [isActiveFieldDisabled, setIsActiveFieldDisabled] = useState(true);
  const [recruitmentLeaderOptions, setRecruitmentLeaderOptions] = useState([]);
  const [teamLeaderOptions, setTeamLeaderOptions] = useState([]);
  const [recruiterOptions, setRecruiterOptions] = useState([]);
  const [recruiterOptionsDelete, setRecruiterOptionsDelete] = useState([]);
  const [isSearching, setIsSearching] = useState(true);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setOpenDialog(true);
    setEditedRow({});
  };
  const [modalIsOpen, setmodalIsOpen] = useState({ confirm: false, divisionChange: false });
  const [recLeadRequisitionData, setRecLeadRequisitionData] = useState([])
  const [mergeTeamDialogOpen, setMergeTeamDialogOpen] = useState(false)
  const [dataWithTeamSelected, setDataWithTeamSelected] = useState([])
  const [mergeToValue, setMergeToValue] = useState("")
  const [editedMergeData, setEditedMergeData] = useState({})
  const activeDropDown = [
    { name: "True", value: true },
    { name: "False", value: false },
  ];

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditedRow({});
    setTeamInfo({
      teamName: "",
      teamId: "",
      recruitmentLeader: "",
      teamLeader: "",
      selectedRecruiterId: [],
      selectedRecruiter: [],
      isActive: { name: "True", value: true },
    });
    setRecruiterOptions(recruiterOptionsDelete);
    setIsActiveFieldDisabled(true);
  };

  const handleMergeTeamDialogOpen = () => {
    setMergeTeamDialogOpen(true)
  }

  const handleMergeTeamDialogClose = () => {
    setMergeTeamDialogOpen(false)
    setMergeToValue("")
    setTeamInfo({
      teamName: "",
      teamId: "",
      recruitmentLeader: "",
      teamLeader: "",
      selectedRecruiterId: [],
      selectedRecruiter: [],
      isActive: { name: "True", value: true },
    });
  }

  const handelEditOpenDialog = () => {
    setOpenDialog(true);
  };

  const openDialogRecruiter = () => {
    setIsDialogOpen(true);
  };

  const closeDialogRecruiter = () => {
    setIsDialogOpen(false);
  };

  const closeModal = (field, value) => {
    setmodalIsOpen(elem => ({ ...elem, [field]: value }));
  }

  const openModel = (field, value) => {
    setmodalIsOpen(elem => ({ ...elem, [field]: value }));

  }

  // Custom filter functions for DataTable
  const isActiveFilterFn = (row, columnId, filterValue) => {
    if (!filterValue) return true;
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  };

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    const activityOptions = [
      { label: 'All', value: '' },
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ];
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  };

  // Column definitions for DataTable
  const columns = [
    {
      accessorKey: "teamName",
      header: "Team",
      size: 180,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "recruiterLeader.email",
      header: "Recruitment Leader",
      size: 220,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "teamLeader.email",
      header: "Team Leader",
      size: 220,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
      cell: ({ getValue }) => getValue() || "N/A",
    },
    {
      accessorKey: "teamSize",
      header: "Team Size",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={[
            { label: 'All', value: '' },
            { label: 'True', value: 'true' },
            { label: 'False', value: 'false' }
          ]}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },
    {
      id: "action",
      header: "Action",
      size: 250,
      enableColumnFilter: false,
      cell: ({ row }) => (
        <div className="actionbuttonContainer_manageTeam">
          <button
            className="editBtn_manageTeam"
            onClick={() => handleEdit(row.original)}
            disabled={userType === "Admin" ? true : false}
          >
            Edit
          </button>
          <button
            className="mergeBtn_manageTeam"
            onClick={() => handleMergedTeam(row.original)}
            disabled={userType === "Admin" || row.original.isActive === false}
          >
            Merge Team
          </button>
        </div>
      ),
    }
  ];

  const goToDashboard = () => {
    history("/dashboard",
      {
        state: {
          userType: userType,
          recruitmentPartnerId: userRecruitmentpartnerId,
          id: idContextTest,
          userRecords: userRecordData,
          roleName: userRole,
        },
      });
  };

  const fetchRecruitmentLeaderDetails = async () => {
    let payload = {
      recruitmentpartnerId: userRecruitmentpartnerId,
      manageDivision: false,
    };
    try {
      const recruitmentLeaderDetails = await getRecruitmentLeaderbyorg(payload);
      if (recruitmentLeaderDetails.status === 200) {
        setRecruitmentLeaderOptions(recruitmentLeaderDetails.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTeamLeaderDetails = async () => {
    let payload = {
      recruitmentpartnerId: userRecruitmentpartnerId,
    };
    try {
      let teamLeaderDetails = await getAllTeamLeaderByOrg(payload);
      if (teamLeaderDetails.status === 200) {
        setTeamLeaderOptions(teamLeaderDetails.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRecruiterDetails = async () => {
    let payload = {
      recruitmentpartnerId: userRecruitmentpartnerId,
    };
    try {
      let recruiterDetails = await getRecruiterDetails(payload);

      if (recruiterDetails.status === 200) {
        setRecruiterOptions(recruiterDetails.data.data);
        setRecruiterOptionsDelete(recruiterDetails.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllTeamDetails = async () => {
    setIsSearching(true);
    setAllTeam([]);
    setdefaultTeamRecruiter([]);
    let payload = {
      recruitmentpartnerId: userRecruitmentpartnerId,
    };
    try {
      const allTeamDetails = await getTeamDetails(payload);
      if (allTeamDetails.status === 200) {
        setAllTeam(allTeamDetails.data.data);
        setdefaultTeamRecruiter(allTeamDetails.data.data);
      }
      setIsSearching(false);
    } catch (error) {
      setIsSearching(false);
      setAllTeam([]);
      console.log(error);
    }
  };

  useEffect(() => {
    if (userRecruitmentpartnerId && (
      userType === "Organization Admin" ||
      userType === "MIS Operator" ||
      (userType === "Admin" && userRole === "Organization Admin") ||
      (userType === "Admin" && userRole === "MIS Operator")
    )) {
      fetchRecruiterDetails();
      fetchRecruitmentLeaderDetails();
      fetchTeamLeaderDetails();
      fetchAllTeamDetails();
    }
  }, [userRecruitmentpartnerId, userType]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleTeamName = (e) => {
    if (e.target.value) {
      setTeamInfo({ ...teamInfo, teamName: e.target.value });
    } else {
      setTeamInfo({ ...teamInfo, teamName: "" });
    }
  };


  const handleRecruitmentLeader = (e, value) => {
    setTeamInfo({ ...teamInfo, recruitmentLeader: value });
    fetchRequisitions()
  };

  const fetchRequisitions = async (assignedTo) => {
    try {
      const payload = {
        assignedTo: editedRow.recruiterLeaderId,
        recruitmentpartnerId: userRecruitmentpartnerId,
        teamId: editedRow._id
      };

      const response = await getAllRequisitionOfRecLead(payload);
      setRecLeadRequisitionData(response.data.data)
    } catch (error) {
      console.error("Error fetching requisitions:", error);
    }
  };



  const handleTeamLeader = (e, value) => {
    setTeamInfo({ ...teamInfo, teamLeader: value });
  };

  const handleRecruiterChange = (e, value) => {
    let latestValue = value[value.length - 1];
    if (value) {
      if (latestValue.id) {
        setTeamInfo({ ...teamInfo, selectedRecruiter: value });
      }
    } else {
      setTeamInfo({ ...teamInfo, selectedRecruiter: [] });
    }
  };

  const handleMergeToChange = (e, value) => {
    if (value) {
      setMergeToValue(value)
    }
    else {
      setMergeToValue("")
    }
  }

  const deleteRecruiterOptionHandler = async (e, option) => {
    try {
      let payload = {
        recruiterId: option.id,
        recruitmentpartnerId: userRecruitmentpartnerId,
        validation: "RecruiterAssignedRequisition",
        teamId: editedRow?._id
      };
      const activeRecruiter = teamActiveRecruiter.filter(
        (ele) => ele.id !== payload.recruiterId
      );

      const selectedRecruiter = teamActiveRecruiter.filter(
        (ele) => ele.id === payload.recruiterId
      );

      const defaultRec = defaultTeamRecruiter.filter(
        (ele) => ele._id === teamInfo.teamId
      );

      const dataRes = await checkExistsRequisition(payload);
      if (dataRes?.data?.data?.length > 0) {
        const arr = defaultRec[0]?.recruiter;
        const arrnew = teamInfo.selectedRecruiter;
        const areElementsIdentical =
          arr.length === arrnew.length &&
          arr.every((element) => arrnew.some((item) => item.id === element.id));

        if (areElementsIdentical) {
          setteamRecruiter(activeRecruiter);
          setSelctedRecruiter(selectedRecruiter[0]);
          setopenDialogRecruiterAssingment(true);
          setOpenDialog(false);
          const reasssingRecruiter = {};
          const allRequ = dataRes?.data?.data;
          for (let i = 0; i < dataRes?.data?.data.length; i++) {
            allRequ[i].reasssingRecruiter = reasssingRecruiter;
          }
          setactiveRequAssign(allRequ);
        } else {
          NotificationManager.error(
            `Save the changes first before removing the recruiter`,
            "error",
            10000
          );
        }
      } else if (dataRes.status === 400 && dataRes.errorCode === 400) {
        const errorMessage = dataRes.data.message;
        NotificationManager.error(errorMessage, "Error", 10000);
      } else {
        const matchRecruiter = teamInfo.selectedRecruiter.filter(
          (item) => item.id === option.id
        );
        const newRecruiterOptions = teamInfo.selectedRecruiter.filter(
          (item) => item.id !== option.id
        );
        const newRecruiterid = teamInfo.selectedRecruiterId.filter(
          (item) => item !== option
        );
        setTeamInfo({
          ...teamInfo,
          selectedRecruiter: newRecruiterOptions,
          selectedRecruiterId: newRecruiterid,
        });
        if (
          recruiterOptions.every((element) =>
            matchRecruiter.some((item) => item.id !== element.id)
          )
        )
          setRecruiterOptions([...recruiterOptions, ...matchRecruiter]);
      }
    } catch (error) {
      NotificationManager.error("Something Went Wrong!", "error", 10000);
      console.log({ error });
    }
  };

  const handleActiveChange = async (e, value) => {
    if (value) {
      setTeamInfo({ ...teamInfo, isActive: value });
    } else {
      setTeamInfo({ ...teamInfo, isActive: "" });
    }
  };

  const handleSubmit = async (_, swapDivision = false) => {
    if (
      teamInfo.teamName === "" ||
      teamInfo.recruitmentLeader === "" ||
      teamInfo.selectedRecruiter.length === 0 ||
      teamInfo.isActive === ""
    ) {
      return NotificationManager.error(
        "Please fill in all the fields",
        "Error",
        10000
      );
    } else {
      setIsUserDataUpdating(true);
      let selectedRecruitersIds = [];
      for (let i = 0; i < teamInfo.selectedRecruiter.length; i++) {
        let item = teamInfo.selectedRecruiter[i];
        selectedRecruitersIds.push(item.id);
      }

      let payload = {
        teamName: teamInfo.teamName,
        recruitmentpartnerId: userRecruitmentpartnerId,
        recruiterLeaderId: teamInfo.recruitmentLeader.id,
        teamLeaderId: teamInfo?.teamLeader?.id || null,
        recruiterId: selectedRecruitersIds,
        isActive: teamInfo.isActive.value,
        updatedBy: idContextTest,
        oldTeamLeaderId: editedRow.teamLeaderId,
        oldRecruitmentLeaderId: editedRow.recruiterLeaderId,
        isTeamLeaderChange: false,
        isRecruitmentLeaderChange: false,
        recruitmentLeaderEmail: teamInfo.recruitmentLeader.email,
        userRecruitmentpartnerId: userRecruitmentpartnerId,
        userId: idContextTest,
        swapDivision
      };

      if (Object.keys(editedRow).length > 0) {
        payload.id = editedRow._id;
        if (editedRow.recruiterLeaderId !== teamInfo.recruitmentLeader.id) {
          payload.isRecruitmentLeaderChange = true;
        }
        if (editedRow.teamLeaderId !== teamInfo?.teamLeader?.id) {
          payload.isTeamLeaderChange = true;
        }
        payload.isNameChange = editedRow.teamName !== teamInfo.teamName ? true : false;
        payload.teamReactive = editedRow.isActive === false && teamInfo.isActive.value === true ? true : false;
        try {
          let response = await updateTeamDetail(payload);
          if (response.status === 200) {
            NotificationManager.success(
              `${response.data.message}`,
              "Success",
              10000
            );
            fetchRecruiterDetails();
            fetchRecruitmentLeaderDetails();
            fetchTeamLeaderDetails();
            fetchAllTeamDetails();
            closeModal()
            setOpenDialog(false);
            handleCloseDialog();

          } else if (response.status === 400 && response.errorCode === 400) {
            const errorMessage = response.data.message;
            NotificationManager.error(errorMessage, "Error", 10000);
          }
        } catch (error) {
          if (error?.response?.data?.message === "Recruitment Leader already exists in another division") {
            setmodalIsOpen(elem => ({ ...elem, divisionChange: true }))
          }
          else if (error?.response?.status === 400) {
            NotificationManager.error(
              error?.response?.data?.message,
              "Error",
              10000
            );
            setIsUserDataUpdating(false);
            // setopenDialogRecruiterAssingment(true);
          } else {
            NotificationManager.error("Something went wrong", "Error", 10000);
          }
        }
      } else {
        payload.createdBy = idContextTest;
        try {
          const addTeamDetails = await addTeam(payload);
          if (addTeamDetails.status === 200) {
            NotificationManager.success(
              `${addTeamDetails.data.message}`,
              "Success",
              10000
            );

            fetchRecruiterDetails();
            fetchRecruitmentLeaderDetails();
            fetchTeamLeaderDetails();
            fetchAllTeamDetails();
            closeModal()
            setOpenDialog(false);
            handleCloseDialog();
          } else if (
            addTeamDetails.status === 400 &&
            addTeamDetails.errorCode === 400
          ) {
            const errorMessage = addTeamDetails.data.message;
            NotificationManager.error(errorMessage, "Error", 10000);
          }
        } catch (error) {
          if (error.response.status === 400) {
            NotificationManager.error(
              error?.response?.data?.message,
              "Error",
              10000
            );
            setIsUserDataUpdating(false);
          }
        }

      }
      setIsUserDataUpdating(false);
    }
  };

  const handleMergedTeam = async (rowData) => {
    handleMergeTeamDialogOpen()
    setTeamInfo({
      ...teamInfo,
      teamId: rowData._id,
      teamName: rowData.teamName,
      recruitmentLeader: rowData.recruiterLeader,
      teamLeader: rowData.teamLeader,
      selectedRecruiterId: rowData.recruiterId,
      selectedRecruiter: rowData.recruiter,
      isActive: {
        name: rowData.isActive ? "True" : "False",
        value: rowData.isActive,
      },
      allRecruiters: rowData.recruiter.map(elem => ({ ...elem, selected: false }))
    });
    setEditedMergeData(rowData)
    const mergedTeam = allTeam.filter((team) => (team._id !== rowData._id) && (team.isActive === true))
    setDataWithTeamSelected(mergedTeam)

    try {
      const payload = {
        assignedTo: rowData.recruiterLeaderId,
        recruitmentpartnerId: userRecruitmentpartnerId,
        teamId: rowData._id
      };

      const response = await getAllRequisitionOfRecLead(payload);
      setRecLeadRequisitionData(response.data.data)
    } catch (error) {
      console.error("Error fetching requisitions:", error);
    }
  }


  const saveHandleMerge = async () => {
    setIsUserDataUpdating(true);
    if (mergeToValue === "") {
      NotificationManager.error("Please fill in all the fields", "Error", 10000);
      setIsUserDataUpdating(false);
      return;
    }

    let recTranfer = [];
    for (let rec of teamInfo.allRecruiters) {
      if (rec.selected) {
        recTranfer.push(rec.id);
      }
    }

    if (recTranfer.length === 0) {
      NotificationManager.error("Please select atleast one recruiter", "Error", 10000);
      setIsUserDataUpdating(false);
      return;
    }

    let payload = {
      oldTeamId: editedMergeData._id,
      newTeamId: mergeToValue._id,
      recruitmentpartnerId: userRecruitmentpartnerId,
      createdBy: idContextTest,
      newRLEmail: mergeToValue.recruiterLeader.email,
      newTeamName: mergeToValue.teamName,
      userId: idContextTest,
      recruiters: recTranfer
    }

    try {
      const resp = await mergeTeam(payload)
      NotificationManager.success(`${resp.data.message}`, "Success", 10000);
      setMergeTeamDialogOpen(false)
      fetchAllTeamDetails();
      handleMergeTeamDialogClose()
    } catch (error) {
      NotificationManager.error(`${error?.response?.data?.errMessage || error?.response?.data?.message || "something went wrong!"}`, "Error", 10000);
    } finally {
      setIsUserDataUpdating(false);
    }
  };

  const handleRecruiterSelection = (selectedRec) => {
    setTeamInfo(elem => {
      // toggle checkbox for selected Recruiter
      let recruiters = elem.allRecruiters.map((innerElem) => ({
        ...innerElem,
        selected: selectedRec.email === innerElem.email ? !innerElem.selected : innerElem.selected
      }))

      return { ...elem, allRecruiters: recruiters }
    })
  };

  const handleEdit = async (rowData) => {
    setTeamInfo({
      ...teamInfo,
      teamId: rowData._id,
      teamName: rowData.teamName,
      recruitmentLeader: rowData.recruiterLeader,
      teamLeader: rowData.teamLeader,
      selectedRecruiterId: rowData.recruiterId,
      selectedRecruiter: rowData.recruiter,
      isActive: {
        name: rowData.isActive ? "True" : "False",
        value: rowData.isActive,
      },
    });
    setEditedRow(rowData);
    handelEditOpenDialog();
    try {
      let payload = {
        teamId: rowData._id,
        recruitmentpartnerId: userRecruitmentpartnerId,
        recruiterLeader: rowData.recruiterLeader.id,
        validation: "Team",
      };
      const activeRecruiter = allTeam.filter(
        (rec) => rec._id === payload.teamId
      );
      setTeamActiveRecruiter(activeRecruiter[0]?.recruiter);
      const data = await checkExistsRequisition(payload);
      const requisitionExists = data?.data?.data;
      if (requisitionExists > 0 && rowData) {
        setIsActiveFieldDisabled(true);
      } else {
        setIsActiveFieldDisabled(false);
      }
      setIsActiveFieldDisabled(elem => !rowData.isActive ? false : elem)
    } catch (error) {
      NotificationManager.error("Something Went Wrong!", "error", 10000);
    }
  };

  return (
    <>
      {userType === "Organization Admin" ||
        userType === "MIS Operator" ||
        (userType === "Admin" && userRole === "Organization Admin") ||
        (userType === "Admin" && userRole === "MIS Operator") ? (
        <>
          <div className="manegeTeam_container">
            <div className="manageTeam_header_container">
              <div className="manageTeam_header_left">
                <div className="manageTeam_goBackButton" onClick={(e) => goToDashboard(e)}>
                  <Tooltip title="Go Back to Dashboard" placement="bottom">
                    <ArrowBackIcon sx={{ fontSize: 20 }} />
                  </Tooltip>
                </div>
                <div className="manageTeam_title">Manage Team</div>
              </div>
              {userType === "Admin" ? (
                ""
              ) : (
                <div className="manageTeam_header_right">
                  <Button
                    className="manageTeam_addButton"
                    onClick={handleOpenDialog}
                    startIcon={<PeopleIcon />}
                  >
                    Add Team
                  </Button>
                </div>
              )}
            </div>

            <DataTable
              data={allTeam}
              columns={columns}
              isLoading={isSearching}
              initialColumnFilters={[
                {
                  id: 'isActive',
                  value: 'true'
                }
              ]}
              initialPageSize={10}
              className="dataTable_team"
            />
            <ReassignRecruiterModal
              setopenDialogRecruiterAssingment={setopenDialogRecruiterAssingment}
              openDialogRecruiterAssingment={openDialogRecruiterAssingment}
              teamInfo={teamInfo}
              setTeamInfo={setTeamInfo}
              setRecruiterOptions={setRecruiterOptions}
              recruiterOptions={recruiterOptions}
              setactiveRequAssign={setactiveRequAssign}
              activeRequAssign={activeRequAssign}
              selctedRecruiter={selctedRecruiter}
              teamRecruiter={teamRecruiter}
              handleSubmit={handleSubmit}
              setOpenDialog={setOpenDialog}
            />
          </div>
        </>
      ) : (
        <UnauthorizedAccess />
      )}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="dialog-title"
        maxWidth="sm"
        fullWidth={true}
        className="add-team"
      >
        <div className="team_dialog_modal">
          <div className="team-dialog-TitleContainer">
            <PeopleIcon className="iconStyle" />
            <span className="dialog-title-text">
              {Object.keys(editedRow).length > 0 ? "Edit Team" : "Add Team"}
            </span>
          </div>
        </div>
        <DialogContent className="team-dialog-content">
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <Typography className="field-title-team-dialog">
                Team Name*
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                className="input-field-team-dialog"
                placeholder="Enter Team Name"
                value={teamInfo.teamName}
                onChange={handleTeamName}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography className="field-title-team-dialog">
                Recruitment Leader*
              </Typography>
              <Autocomplete
                id="combo-box-demo"
                options={recruitmentLeaderOptions}
                getOptionLabel={(option) => option.email || ""}
                value={teamInfo.recruitmentLeader}
                disableClearable
                filterSelectedOptions
                onChange={handleRecruitmentLeader}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Recruitment Leader"
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography className="field-title-team-dialog">
                Team Leader
              </Typography>
              <Autocomplete
                id="combo-box-demo"
                options={teamLeaderOptions}
                getOptionLabel={(option) => option.email || ""}
                value={teamInfo.teamLeader}
                filterSelectedOptions
                onChange={handleTeamLeader}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Team Leader"
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography className="field-title-team-dialog">
                Recruiter*
              </Typography>
              <FormControl fullWidth variant="outlined">
                <Autocomplete
                  id="multiple-recruiter-tags"
                  multiple
                  freeSolo
                  filterSelectedOptions
                  disableClearable
                  options={recruiterOptions}
                  value={teamInfo.selectedRecruiter}
                  getOptionLabel={(option) => option.email}
                  onChange={handleRecruiterChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Recruiters"
                      onKeyDown={(event) => {
                        if (event.key === "Backspace") {
                          event.stopPropagation();
                        }
                      }}
                      style={{
                        backgroundColor: "#fff",
                        color: "#000",
                        borderRadius: 4,
                        borderColor: "#31b3f8",
                      }}
                    />
                  )}
                  renderTags={(value, getTagProps) => {
                    if (value.length > 3) {
                      const firstTwo = value.slice(0, 3);
                      const remainingCount = value.length - 3;
                      return (
                        <>
                          {firstTwo.map((option, index) => (
                            <Chip
                              label={option.email}
                              {...getTagProps({ index })}
                              onDelete={(e) =>
                                deleteRecruiterOptionHandler(e, option)
                              }
                            />
                          ))}
                          <Chip
                            label={`+${remainingCount} more`}
                            onClick={openDialogRecruiter}
                          />
                        </>
                      );
                    }
                    return value.map((option, index) => (
                      <Chip
                        label={option.email}
                        {...getTagProps({ index })}
                        onDelete={(e) =>
                          deleteRecruiterOptionHandler(e, option)
                        }
                      />
                    ));
                  }}
                />

                <Dialog
                  open={isDialogOpen}
                  onClose={closeDialogRecruiter}
                  fullWidth
                  maxWidth="md"
                  className="team_dialog"
                >
                  <div className="team_dialog_modal">
                    <div className="team-dialog-TitleContainer">
                      <span className="dialog-title-text">
                        Selected Recruiters
                      </span>
                    </div>
                  </div>
                  <DialogContent>
                    <Autocomplete
                      id="multiple-recruiter-tags-dialog"
                      multiple
                      freeSolo
                      filterSelectedOptions
                      options={recruiterOptions}
                      value={teamInfo.selectedRecruiter}
                      getOptionLabel={(option) => option.email}
                      disableClearable
                      onChange={handleRecruiterChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select Recruiters"
                        />
                      )}
                      renderTags={(value, getTagProps) => {
                        return value.map((option, index) => (
                          <Chip
                            label={option.email}
                            {...getTagProps({ index })}
                            onDelete={(e) =>
                              deleteRecruiterOptionHandler(e, option)
                            }
                          />
                        ));
                      }}
                    />
                  </DialogContent>
                  <DialogActions>
                    <button
                      onClick={closeDialogRecruiter}
                      className="close_button_team"
                    >
                      Close
                    </button>
                  </DialogActions>
                </Dialog>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography className="field-title-team-dialog">
                Is Active*
              </Typography>
              <Autocomplete
                id="combo-box-demo"
                options={activeDropDown}
                getOptionLabel={(option) => option?.name}
                value={teamInfo.isActive}
                disabled={editedRow ? isActiveFieldDisabled : false}
                onChange={handleActiveChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Active"
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-actionbutton-team">
          <button onClick={handleCloseDialog} className="cancel-button-team">
            Cancel
          </button>
          <button
            className="updateButton-team"
            onClick={Object.keys(editedRow).length > 0 && (editedRow.recruiterLeaderId !== teamInfo.recruitmentLeader?.id) ? (e) => openModel("confirm", true) : handleSubmit}
            disabled={isUserDataUpdating}
          >
            <span>Save</span>
            {isUserDataUpdating ? (
              <CircularProgress className="circularProgress_mergeButton_team" />
            ) : null}
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={closeModal}
        open={modalIsOpen.confirm}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth={true}
      >
        <div className="team_dialog_modal">
          <div className="team-dialog-TitleContainer">
            <span className="dialog-title-text">
              Confirmation
            </span>
          </div>
        </div>
        <DialogContent>
          <div className="fs-semi-bold f-color fs-18">
            Do you want to transfer all the Requisition to {teamInfo.recruitmentLeader.email}?
          </div>
          <div className="requisition-list">
            {recLeadRequisitionData &&
              recLeadRequisitionData.map((item) => (
                <span key={item._id} className="requisition-item">{item.reqreferenceId}</span>
              ))}

          </div>
        </DialogContent>
        <DialogActions>
          <div className='dialog-actionbutton-team-model'>

            <button variant="contained" className="updateButton-team-model" onClick={() => { handleSubmit("_", false); closeModal("confirm", false) }}
            >
              Confirm
            </button>
            <button variant="contained" color="secondary" className='cancel-button-team' onClick={() => closeModal("confirm", false)}
            >
              Cancel
            </button>
          </div>
        </DialogActions>

      </Dialog>

      <Dialog
        // onClose={closeModal}
        open={modalIsOpen.divisionChange}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth={true}
      >
        <div className="team_dialog_modal">
          <div className="team-dialog-TitleContainer">
            <span className="dialog-title-text">
              Confirmation
            </span>
          </div>
        </div>
        <DialogContent>
          <div className="fs-semi-bold f-color fs-18">
            Selected Recruitment Leader is from another division, want to still change?
          </div>
        </DialogContent>
        <DialogActions>
          <div className='dialog-actionbutton-team-model'>

            <button variant="contained" className="updateButton-team-model" onClick={() => { handleSubmit("_", true); closeModal("divisionChange", false) }}
            >
              Confirm
            </button>
            <button variant="contained" color="secondary" className='cancel-button-team' onClick={() => closeModal("divisionChange", false)}
            >
              Cancel
            </button>
          </div>
        </DialogActions>
      </Dialog>
      {/* model for merged team */}
      <MergeTeamModal
        mergeTeamDialogOpen={mergeTeamDialogOpen}
        teamInfo={teamInfo}
        handleTeamName={handleTeamName}
        mergeToValue={mergeToValue}
        dataWithTeamSelected={dataWithTeamSelected}
        recLeadRequisitionData={recLeadRequisitionData}
        handleRecruiterSelection={handleRecruiterSelection}
        saveHandleMerge={saveHandleMerge}
        isUserDataUpdating={isUserDataUpdating}
        handleMergeTeamDialogClose={handleMergeTeamDialogClose}
        handleMergeToChange={handleMergeToChange}
      />
    </>
  );
};

export default ManageTeam;
